import { createSlice } from '@reduxjs/toolkit';
import TokenParser from '../../utils/tokenParser';

const scopeSlice = createSlice({
    name: 'scope',
    initialState: {
        scopes: [],
    },
    reducers: {
        setScopes: {
            reducer(state, action) {
                state.scopes = action.payload;
            },
            // Наружу уходит токен, в состояние — разобранные из него роли.
            prepare(token) {
                return { payload: TokenParser.parseScopes(token) };
            },
        },
        resetScopes(state) {
            state.scopes = [];
        },
    },
});

export const { setScopes, resetScopes } = scopeSlice.actions;
export default scopeSlice.reducer;
